import { useMutation } from "@tanstack/react-query";

import graphQLClient from "../../utils/authHeader";
import { VERIFY_CHANGE_EMAIL_TAG } from "../../utils/mutations/updateProfile/updateEmail";

interface UseMutationProps {
  onSuccess: Function;
  onError: Function;
}

export const useVerifyChangeEmailMutation = ({
  onSuccess,
  onError,
}: UseMutationProps) => {
  const request = async (props: { token: string }) => {
    const { token } = props;
    const variables = {
      verifyChangeEmailInput: {
        token,
      },
    };
    const result = await graphQLClient.request(
      VERIFY_CHANGE_EMAIL_TAG,
      variables
    );

    const data = result?.verifyChangeEmail;

    return data;
  };

  const mutation = useMutation({
    mutationFn: (prop: { token: string }) => {
      return request(prop);
    },
    onError: (error: any, variables: any, context: any) => {
      console.log(`rolling back optimistic update with id ${context.id}`);
      onError(error);
    },
    onSuccess: (dataPayload: any) => {
      onSuccess(dataPayload);
    },
  });

  return mutation;
};
